import { render } from "./DoctorLayout.vue?vue&type=template&id=3285b6d4&scoped=true"
import script from "./DoctorLayout.vue?vue&type=script&lang=js"
export * from "./DoctorLayout.vue?vue&type=script&lang=js"

import "./DoctorLayout.vue?vue&type=style&index=0&id=3285b6d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3285b6d4"]])

export default __exports__